import React, { createContext, useContext } from 'react';

import { useStoreContext } from 'features/store';

import { IBaseProps } from '@rbi-ctg/frontend';
import usePosVendor from 'hooks/menu/use-pos-vendor';
import { IUsePricingFunctionHookReturnType } from 'types/menu-pricing';

import { usePricingFunction } from './hooks/use-pricing-function';

export type IMenuPricingContext = IUsePricingFunctionHookReturnType;

export const MenuPricingContext = createContext<IMenuPricingContext>({} as IMenuPricingContext);
export const useMenuPricingContext = () => useContext(MenuPricingContext);

export const MenuPricingProvider = ({ children }: IBaseProps) => {
  const { prices } = useStoreContext();
  const { vendor: posVendor } = usePosVendor();

  const value = usePricingFunction({
    prices,
    vendor: posVendor,
  });

  return <MenuPricingContext.Provider value={value}>{children}</MenuPricingContext.Provider>;
};

export default MenuPricingContext.Consumer;
